import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DeletedesignComponent } from 'src/app/components/modal/deletedesign/deletedesign.component';
import { DesignService } from 'src/app/service/design.service';

@Component({
  selector: 'app-designs',
  templateUrl: './designs.component.html',
  styleUrls: ['./designs.component.scss']
})
export class DesignsComponent implements OnInit {

  designs: any = [];
  deletedDesigns: any = []
  cols = 4

  constructor(private designService: DesignService, private dialog: MatDialog) { }

  onResize(event) {
    if (event.target.innerWidth > 768) {
      this.cols = 4
    }
    else if (event.target.innerWidth <= 768) {
      this.cols = 1
    }
  }

  openDialog(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      id:id
    }
    this.dialog.open(DeletedesignComponent, dialogConfig);
  }

  deleteDesign(id) {
    this.openDialog(id);
  }

  goToDesign(design, id) {
    this.designService.goToDesign(design, id)
  }

  restoreDesign(id, doc) {
    doc.deleted = false;
    this.designService.updateDesign(id, doc);
  }

  ngOnInit(): void {
    if (window.innerWidth <= 768) {
      this.cols = 1
    }
    this.designService.getDesigns().subscribe((designs) => {
      this.designs = []
      designs.forEach(design => {
        this.designs.push({ data: design.payload.doc.data(), img: './assets/image/Tree with characters.png', id: design.payload.doc.id })
      });
      this.designs.sort((a: any, b: any) => {
        return <any>new Date(b.data.saved * 1000) - <any>new Date(a.data.saved * 1000);
      });
    })
    this.designService.getDeltedDesigns().subscribe((deleted) => {
      this.deletedDesigns = []
      deleted.forEach(design => {
        this.deletedDesigns.push({ data: design.payload.doc.data(), img: './assets/image/Tree with characters.png', id: design.payload.doc.id })
      });
      this.deletedDesigns.sort((a: any, b: any) => {
        return <any>new Date(a.data.saved * 1000) - <any>new Date(b.data.saved * 1000);
      });
    })

  }

}
